import React from "react";
import { Link } from "react-router-dom";
import { LocaleLink } from "@/components/LocaleLink";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { StoreBadgeGroup } from "@/components/StoreBadges";

const NotFoundPage = () => {
  const { t } = useTranslation("site");
  const tk = (k, fb) => t(`notFound.${k}`, fb);
  return (
    <section className="relative pb-24">
      <AuroraBackground variant="hero" />
      <div className="relative mx-auto max-w-2xl px-5 lg:px-8 pt-12 text-center">
        <p className="eyebrow">{tk("kicker")}</p>
        <h1 className="mt-3 font-serif text-[3rem] sm:text-6xl tracking-tight font-light leading-tight">
          {tk("title1")}{" "}<em className="italic aurora-shimmer-text">{tk("title2")}</em>
        </h1>
        <p className="mt-5 text-white/72 font-light">{tk("subtitle")}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <LocaleLink to="/" className="btn-aurora">{tk("cta1")}</LocaleLink>
          <LocaleLink to="/features" className="btn-ghost">{tk("cta2")}</LocaleLink>
        </div>
        <div className="mt-10">
          <StoreBadgeGroup showStart={false} />
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
